export { default } from './Tab';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Tab/index.js
// module id = 421
// module chunks = 121